import { useState } from "react";
import { FAQS } from "@/lib/faqs";
import { useReveal } from "@/hooks/useReveal";

export const FAQ = () => {
  const ref = useReveal();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="pt-8 pb-8 lg:pt-10 lg:pb-12 relative">
      <div className="mx-auto max-w-5xl px-5 lg:px-10">
        <div ref={ref} className="reveal max-w-3xl mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--accent))] font-semibold">
            Ofte stillede spørgsmål
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-3 leading-[1.05]">
            Spørgsmål vi får{" "}
            <span className="italic font-light text-white/60">tit.</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-2xl text-base">
            Alt fra hvad et samarbejde koster, til hvad SEO egentlig er. Hvis du har et spørgsmål der ikke
            er besvaret her, så skriv til os.
          </p>
        </div>

        <div className="space-y-2.5">
          {FAQS.map((item, i) => (
            <FaqItem
              key={i}
              q={item.q}
              a={item.a}
              isOpen={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
              index={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const FaqItem = ({ q, a, isOpen, onToggle, index }) => (
  <div
    data-testid={`faq-item-${index}`}
    className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
      isOpen
        ? "border-[hsl(var(--accent))]/50 bg-[hsl(var(--accent))]/[0.03]"
        : "border-white/10 bg-[hsl(var(--bg-card))] hover:border-white/20"
    }`}
  >
    <button
      type="button"
      onClick={onToggle}
      data-testid={`faq-toggle-${index}`}
      aria-expanded={isOpen}
      className="w-full text-left px-6 sm:px-7 py-5 flex items-center justify-between gap-4"
    >
      <span className={`font-display text-base sm:text-lg font-semibold transition-colors ${
        isOpen ? "text-[hsl(var(--accent))]" : "text-white"
      }`}>
        {q}
      </span>
      <span
        className={`h-8 w-8 flex-shrink-0 rounded-full border grid place-items-center text-base transition-all ${
          isOpen
            ? "border-[hsl(var(--accent))] text-[hsl(var(--accent))] rotate-45"
            : "border-white/20 text-white/70"
        }`}
        aria-hidden
      >
        +
      </span>
    </button>
    <div
      className={`grid transition-[grid-template-rows] duration-300 ease-out ${
        isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
      }`}
    >
      <div className="overflow-hidden">
        <div className="px-6 sm:px-7 pb-6 text-white/70 leading-relaxed text-sm sm:text-base">
          {a}
        </div>
      </div>
    </div>
  </div>
);
